import { ICON__monitor, ICON__monitor_x } from '@/assets/icons_lucide';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_slice_generation, use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar_8_5 } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_8_5';
import { ENUM__page_generation_layout } from '@/pages/page_generation/_enums/ENUM__page_generation_layout';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';

interface PROPS {
  field: FIELD__base;
}

export function G_BUTTON__field_ui_change_visibility({ field }: PROPS) {
  /*
   * STORE
   */

  const { generation_current } = use_slice_generation(['generation_current']);
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);
  const { g_general__ui_disabled, g_general__layout } = use_slice_ui(['g_general__ui_disabled', 'g_general__layout']);

  /*
   * STATE
   */

  /*
   * EVENTS
   */
  async function onClick(e: React.MouseEvent) {
    e?.stopPropagation();

    let field_new = field.clone();
    field_new.meta.ui__is_visible = !field_new.meta.ui__is_visible;

    let graph_new = generation_current.tool.graph.clone();

    graph_new.field__replace(field_new);

    await UTILS__graph_data.update(graph_new);
  }

  function is_disabled() {
    return g_general__ui_disabled;
  }

  /*
   * HTML
   */

  let allowed_layouts = [ENUM__page_generation_layout.NODES, ENUM__page_generation_layout.OUTPUTS];

  if (!allowed_layouts.includes(g_general__layout)) return null;
  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_GENERATION_UPDATE)) return <PLACEHOLDER_BUTTON__bar_8_5 />;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      title={field.meta.ui__is_visible ? 'Remove from UI' : 'Add to UI'}
      variant={'no-border-on-bar'}
      Icon={field.meta.ui__is_visible ? ICON__monitor_x : ICON__monitor}
      disabled={is_disabled()}
      renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
      {...{ onClick }}
      className="w-8 h-5 flex-center"
      iconClassNameBase="size-3 text-gray-400"
      iconClassNameHovered="!text-bar-foreground"
    />
  );
}
